import { render, staticRenderFns } from "./Cadastros.vue?vue&type=template&id=0691076a"
import script from "./Cadastros.vue?vue&type=script&lang=js"
export * from "./Cadastros.vue?vue&type=script&lang=js"
import style0 from "./Cadastros.vue?vue&type=style&index=0&id=0691076a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports